/* 布局 */
//前台
import Layout from "@views/layout";

const sysemailunsubscribeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "sysemailunsubscribe",
            name: "SYSEMAILUNSUBSCRIBE",
            meta: {
                title: "",
                sort: 1,
            },
            component: () => import("@views/business/sysemailunsubscribe/index.vue"),
            redirect: {
                name: "SYSEMAILUNSUBSCRIBE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "SYSEMAILUNSUBSCRIBE_LIST",
                    meta: {
                        title: "",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/sysemailunsubscribe/list.vue"),
                },
                                {
                    path: "add",
                    name: "SYSEMAILUNSUBSCRIBE_ADD",
                    meta: {
                        title: "新增邮件退订地址管理",
                        parentPath: '/business/sysemailunsubscribe/list',
                        operate: true,
                    },
                    component: () => import("@views/business/sysemailunsubscribe/form.vue"),
                },
                                                        ],
    },


        ],
};

export default sysemailunsubscribeRouter;
